import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { Configurator } from '../components/Configurator';
import { getSessionId } from '../lib/utils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fallback data in case API fails
const DEFAULT_KITS = {
  'kit-folgo': {
    id: 'kit-folgo',
    name: 'KIT CADRE FOLGO',
    description: 'Kit cadre FOLGO pour montage personnalisé. Inclut le cadre, la fourche et la direction.',
    base_price: 1500,
    image: 'https://customer-assets.emergentagent.com/job_belleville-bikes/artifacts/yxdx7hsn_KIt%20cadre%20ok.jpg',
    images: ['https://customer-assets.emergentagent.com/job_belleville-bikes/artifacts/yxdx7hsn_KIt%20cadre%20ok.jpg'],
    type: 'kit'
  },
  'kit-cargo': {
    id: 'kit-cargo',
    name: 'KIT CADRE CARGO',
    description: 'Kit cadre CARGO pour montage personnalisé. Inclut le cadre, la fourche et la direction.',
    base_price: 1100,
    image: 'https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?w=800',
    images: ['https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?w=800'],
    type: 'kit'
  }
};

export default function KitCadrePage() {
  const [selectedKit, setSelectedKit] = useState('kit-folgo');
  const [kits, setKits] = useState(DEFAULT_KITS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Log visitor
    axios.post(`${API}/visitor/log`, {
      page: 'kit-cadre',
      session_id: getSessionId(),
      user_agent: navigator.userAgent,
      referrer: document.referrer
    }).catch(() => {});

    // Fetch kit products from API
    const fetchKits = async () => {
      try {
        const response = await axios.get(`${API}/products`);
        const products = response.data;
        
        const kitFolgo = products.find(p => p.id === 'kit-folgo');
        const kitCargo = products.find(p => p.id === 'kit-cargo');
        
        const updatedKits = { ...DEFAULT_KITS };
        
        if (kitFolgo) {
          updatedKits['kit-folgo'] = {
            ...DEFAULT_KITS['kit-folgo'],
            ...kitFolgo,
            image: kitFolgo.images?.[0] || DEFAULT_KITS['kit-folgo'].image,
            type: 'kit'
          };
        }
        
        if (kitCargo) {
          updatedKits['kit-cargo'] = {
            ...DEFAULT_KITS['kit-cargo'],
            ...kitCargo,
            image: kitCargo.images?.[0] || DEFAULT_KITS['kit-cargo'].image,
            type: 'kit'
          };
        }
        
        setKits(updatedKits);
      } catch (error) {
        // Error handled silently
      } finally {
        setLoading(false);
      }
    };

    fetchKits();
  }, []);

  return (
    <div className="min-h-screen bg-white" data-testid="kit-cadre-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        {/* Kit Selection */}
        <div className="mb-12">
          <span className="font-mono text-xs uppercase tracking-widest text-muted-foreground">
            Choisissez votre kit
          </span>
          <h1 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight mt-2">
            Kits Cadre
          </h1>
          
          <div className="grid md:grid-cols-2 gap-4 mt-8">
            {Object.values(kits).map((kit) => (
              <motion.button
                key={kit.id}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => setSelectedKit(kit.id)}
                className={`p-6 border text-left transition-all ${
                  selectedKit === kit.id 
                    ? 'border-black border-2' 
                    : 'border-border hover:border-black'
                }`}
                data-testid={`kit-select-${kit.id}`}
              >
                <h3 className="font-heading font-bold uppercase">{kit.name}</h3>
                <p className="font-mono text-lg font-bold mt-1">{kit.base_price} €</p>
              </motion.button>
            ))}
          </div>
        </div>

        {/* Configurator */}
        <Configurator key={selectedKit} product={kits[selectedKit]} isKit={true} />
      </div>
    </div>
  );
}
